import React, { useState } from 'react';
import xlsImagem from '../../images/xls.png';
import { handleModalStatus } from '../../utils/handleModalStatus';
import { BaSeDialogContext } from '@base/react';
import Spinner from 'react-spinner-material';
import xlsService from '../../services/xlsService';

export const ExcelExportAdmin = ({
  handleDataCallback,
  filename,
  colorLoading = '#3498db',
  isCsv = false,
}) => {
  const { showModal } = React.useContext(BaSeDialogContext);

  const [downloading, setDownloading] = useState(false);

  const executeDownload = async () => {
    try {
      setDownloading(true);
      const response = await handleDataCallback();
      const responseContent = response?.content ?? response;
      if (responseContent) {
        const file = !!isCsv
          ? xlsService.xlsDownloadCsv(responseContent, filename, () => setDownloading(false))
          : xlsService.xlsDownload(responseContent, filename, () => setDownloading(false));

        file.catch(() => {
          setDownloading(false);
          handleModalStatus({
            type: 'error',
            msgOnError:
              'Houve um erro ao apresentar o relatório. Tente novamente mais tarde.',
            onCloseModal: () => setDownloading(false),
            showModal,
          });
        });
      } else {
        setDownloading(false);
      }
    } catch (e) {
      setDownloading(false);
      handleModalStatus({
        type: 'error',
        msgOnError:
          'Houve um erro ao apresentar o relatório. Tente novamente mais tarde.',
        onCloseModal: () => setDownloading(false),
        showModal,
      });
    }
  };

  if (downloading) {
    return (
      <Spinner radius={40} color={colorLoading} stroke={2} visible={true} />
    );
  }

  return (
    <>
      <div onClick={() => executeDownload()} style={{ width: '3.1rem' }}>
        <img className="xls" alt="imagem" src={xlsImagem} />
      </div>
    </>
  );
};
